import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch, Route } from 'react-router-dom';
import { IHasPageChangeRef } from '../../../../../../../main/interface/has-page-change';
import { useSetFourthLevelRoute } from '../../../../../../hooks/use-set-fourth-level-route';
import CustomFilter from './custom-filter'

interface IMatch {
  path: string;
  params: {
    thirdLevelRoute: string;
  }
}

interface ICustomFilterProps {
  hasPageChangeRef: React.MutableRefObject<IHasPageChangeRef>;
}

class CustomFilterRoute {

  name = 'report-filters';

  render: React.FC<ICustomFilterProps> = (props) => {
    const match: IMatch = useRouteMatch();
    const dispatch = useDispatch();

    useSetFourthLevelRoute({
      dispatch,
      mainRoute: 'admin',
      subRoute: 'business-process',
      thirdLevelRoute: match.params.thirdLevelRoute,
      fourthLevelRoute: this.name,
      currentRoute: this.name
    });

    return (
      <>
        <Route path={`${match.path}`} exact>
          <CustomFilter hasPageChangeRef={props.hasPageChangeRef} />
        </Route>
      </>
    );
  }
}

export default CustomFilterRoute;
